import { useEffect, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const matchMedia = window.matchMedia(query)

    setMatches(matchMedia.matches)

    function handleChange(e: MediaQueryListEvent) {
      setMatches(e.matches)
    }

    matchMedia.addEventListener('change', handleChange)

    return () => {
      matchMedia.removeEventListener('change', handleChange)
    }
  }, [query])

  return matches
}

export function useIsMobile(): boolean {
  return !useMediaQuery('min-width: 768px')
}
